// extracted by mini-css-extract-plugin
module.exports = {"easter-egg-dragon":"easterEgg_easter-egg-dragon__8SpSs","translate-x":"easterEgg_translate-x__i5Uay","easter-egg-corner":"easterEgg_easter-egg-corner__rnUsK"};